import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import '../BattleUIExploreUnknownDarknessFlash.css';

/**
 * @param {{ popupId: string, variant: string, i18nKey: string, imageSrc: string, newCharges: number, onDismiss: () => void }} props
 */
export default function ExploreUnknownEpSetCompleteModal({
  popupId,
  variant,
  i18nKey,
  imageSrc,
  newCharges,
  upgradedFromTarget = false,
  onDismiss,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    playSoundEffect('/sounds/legendary_reveal.mp3');
  }, [popupId]);

  const titleKey = upgradedFromTarget
    ? 'epTargetSetCompleteUpgradedTitle'
    : `${i18nKey}SetCompleteTitle`;
  const bodyKey = upgradedFromTarget
    ? 'epTargetSetCompleteUpgradedBody'
    : `${i18nKey}SetCompleteBody`;

  return createPortal(
    <div className="battle-eu-heart-set-complete-overlay explore-unknown-reward-popup-overlay" onClick={onDismiss}>
      <div
        className={`battle-eu-heart-set-complete-modal battle-eu-heart-set-complete-modal--${variant} explore-unknown-reward-popup-modal`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-unknown-ep-set-complete-title"
      >
        <h3 id="explore-unknown-ep-set-complete-title" className="battle-eu-heart-set-complete-title">
          {t(`exploreUnknownBattle.${titleKey}`)}
        </h3>
        <div className="battle-eu-heart-set-complete-visual">
          <img src={imageSrc} alt="" className="battle-eu-heart-set-complete-image" />
        </div>
        <p className="battle-eu-heart-set-complete-body">
          {t(`exploreUnknownBattle.${bodyKey}`, { charges: newCharges })}
        </p>
        <button type="button" className="battle-eu-heart-set-complete-ok" onClick={onDismiss}>
          {t('exploreUnknownBattle.epSetCompleteOk')}
        </button>
      </div>
    </div>,
    document.body
  );
}
